import { Pipe, PipeTransform } from '@angular/core';
import { ReqService } from '@core/services/req.service';
import { SearchStateService } from '@core/services/search-state.service';
import { CurrencyCode } from '../enums/currency-code.enum';

@Pipe({
  name: 'Currency',
  standalone: true,
})
export class CurrencyPipe implements PipeTransform {
  constructor(
    private contextService: ReqService,
    private searchStateService: SearchStateService,
  ) {}

  transform(item, showCurrencySymbol = false) {
    const country: string = this.contextService.getCountry().toUpperCase();
    const separator: string = country === 'MEX' ? ',' : '.';
    if (item === '-') {
      return item;
    }
    const currency: string = String(Math.ceil(item)).split('').reverse().join('');
    const len: number = currency.length;
    let cu = '';
    for (let i = 0; i < len; i++) {
      if (i !== 0 && !(i % 3)) {
        cu += separator;
      }
      cu += currency[i];
    }
    cu = cu.split('').reverse().join('');
    if (showCurrencySymbol) {
      const currencyCode = this.searchStateService.currencyCode;
      return `${currencyCode === CurrencyCode.ARS ? '$' : 'u$s'} ${cu}`;
    }
    return cu;
  }
}
